import moment from 'moment';

const formatDate = (date) => {
  const formattedDate = moment(date).format('DD/MM/YYYY - HH[h]mm');
  return formattedDate;
};

const pad2 = (value) => String(value).padStart(2, '0');

const getUtcYmd = (dateString) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getUTCFullYear()}-${pad2(date.getUTCMonth() + 1)}-${pad2(date.getUTCDate())}`;
};

const getSaoPauloYmd = (now = new Date()) =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(now);

const formatDateOnly = (dateString, separator = '/') => {
  if (!dateString) return '-';
  const ymd = getUtcYmd(dateString);
  if (!ymd) return '-';
  const [year, month, day] = ymd.split('-');
  return `${day}${separator}${month}${separator}${year}`;
};

const getOverdueDays = (dateString) => {
  if (!dateString) return null;
  const due = getUtcYmd(dateString);
  if (!due) return null;
  const today = getSaoPauloYmd();
  const days = Math.round(
    (Date.parse(`${today}T00:00:00Z`) - Date.parse(`${due}T00:00:00Z`)) / 86400000
  );
  return days > 0 ? days : null;
};

export {
  formatDate,
  formatDateOnly,
  getOverdueDays
}
